import { Http } from "./http"
import { HttpClient } from "./types/client"
import { Vat } from "./endpoints/vat/vat.endpoint"
import { InnovationLabForm } from "./endpoints/innovation/innovation.endpoint"
import { Mailchimp } from "./endpoints/mailchimp/mailchimp.endpoint"
import { Automation } from "./endpoints/automation/automation.endpoint"

export class Client {
  private httpClient: HttpClient
  public vat: Vat
  public innovationLabForm: InnovationLabForm
  public mailchimp: Mailchimp
  public automation: Automation

  constructor(host: string, httpClient?: HttpClient) {
    this.httpClient = httpClient ? httpClient : new Http(host)
    this.vat = new Vat(this.httpClient)
    this.innovationLabForm = new InnovationLabForm(this.httpClient)
    this.mailchimp = new Mailchimp(this.httpClient)
    this.automation = new Automation(this.httpClient)
  }
}
